import YourSubscription from './YourSubscription.component';

export default YourSubscription;